<template>
    <v-form ref="form"
            v-model="valid"
            lazy-validation>


        <v-text-field v-model="Id"
                      label="Id"
                      readonly
                      required></v-text-field>


        <v-text-field v-model="Nombre"
                      :rules="[rules.required]"
                      label="Nombre Membresia"
                      required></v-text-field>

        <v-text-field v-model="dias_vigencia"
                      label="Dias de Vigencia"
                      type="number"
                      :rules="[rules.required, rules.positivo_mayor_cero]"
                      :error-messages="errorMessages"
                      required>
        </v-text-field>

        <v-text-field v-model="firmas_permitidas"
                      label="Maximo firmas permitidas"
                      type="number"
                      :rules="[rules.required, rules.positivo_mayor_cero]"
                      :error-messages="errorMessages"
                      required></v-text-field>

        <v-btn :disabled="!valid"
               color="success"
               class="mr-4"
               @click="validate_and_save">
            Grabar
        </v-btn>

        <v-btn color="error"
               class="mr-4"
               @click="reset">
            Cancelar
        </v-btn>

        <v-snackbar v-model="notificacion_exito">
            {{ texto_notificacion }}
            <v-btn color="pink"
                   text
                   @click="notificacion_exito = false; texto_notificacion.indexOf('Error') >= 0 ? null:reset() ;">
                Cerrar
            </v-btn>
        </v-snackbar>

    </v-form>
</template>
<script>

    import axios from "axios";

    var token = window.localStorage.getItem('jwt_token');
    var headers = {
        Authorization: "Bearer " + token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    export default {
        data: () => ({
            dialog: false,
            valid: true,
            Nombre: '',
            dias_vigencia: '',
            firmas_permitidas: '',
            errorMessages: '',
            Id: '0',
            notificacion_exito: false,
            texto_notificacion: '',
            rules: {
                required: value => !!value || 'Campo Requerido.',
                positivo_mayor_cero: value =>  0 < Number(value) || 'Campo debe ser mayor a cero'
            }
        }),
        mounted() {            
            this.Id = this.$route.params.Id;
            this.cargar_datos_membresia();
        },
        methods: {
            validar_numero_mayor_cero(v) {
                console.log("validando dias de vigencia: " + v );
                if ( v <= 0) {
                    this.errorMessages = 'valor ingresado debe ser mayor a 0';
                }
                else
                    this.errorMessages = '';

                return true;
            },
            validate_and_save() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true

                    let getuser = axios.put('/membresia', { 'Id': this.Id, 'nombre': this.Nombre, 'dias_vigencia': Number( this.dias_vigencia) , 'firmas_permitidas': Number(this.firmas_permitidas) }/*,  { 'headers': headers }*/)
                    return getuser.then((callback) => {
                        let resultado = callback.data;
                        this.texto_notificacion = 'Operacion finalizada con exito';
                        this.notificacion_exito = true;
                        return callback;

                    }).catch((error) => {
                        this.texto_notificacion = 'Error al realizar la operacion : ' + error;
                        this.notificacion_exito = true;
            	        console.log(error);
            	        return false;
                    });
                }
                else {
                    console.log("estoy en el else");
                }
            },
            reset() {
                this.$router.push({ name: "index_membresia" });
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },
            cargar_datos_membresia() {
                  let getMembresias = axios.get('/membresia/' + this.Id );
                return getMembresias.then((callback) =>
                {
                    console.log(callback.data);
                    this.Nombre = callback.data.nombre;
                    this.dias_vigencia = callback.data.dias_vigencia;
                    this.firmas_permitidas = callback.data.firmas_permitidas;
                            
                }).catch((error) => {
                    console.log("ERROR EN EL CALLBACK" + error);
                });
            }
        },
    }
</script>